import React, { Component } from 'react';
import { connect } from 'react-redux';
import Pagination from 'rc-pagination';
import { findSubscriberList, addSubscriber, changeSubStatus, deleteSubscribers } from '../../../api';
import { Link } from 'react-router-dom';
import windowModal from '../../../component/Modal';

@connect(
  state=>state.tenant,
  null
)
export default class Subscribers extends Component{
  constructor(props) {
    super(props);
    this.state = {
      dataRows: [],
      totalRows: 0,
      pageSize: 10,
      currentPage: 1
    };
  }
  componentDidMount() {
    this.mounted = true;
    windowModal();
    this._eventHandler();
    this._initSelect();
    let body = {
      currentPage: 1,
      pageSize: this.state.pageSize
    };
    this._getSubscribers(body);
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  _eventHandler = () => {
    let that = this;
    let _getSubscribers = this._getSubscribers;
    let _resetForm = this._resetForm;
    $("#addForm").validate({
      rules: {
        email: {required: true, email: true},
        clientId:{required:true}
      },
      messages: {
        email: {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address'},
        clientId:{
          required: 'Please enter a company name'}},
      submitHandler:function(){
        let clientId = $("#clientId").val();
        let email = $("#email").val();
        let {loginAdmin, tenantInfo} = that.props;
        let tenantName = loginAdmin === "isos"?tenantInfo.name:loginAdmin;
        addSubscriber({clientId, email, tenantName})
          .then(res=>{
            if (res.status === "success") {
              _resetForm();
              $("#addrow_modal").modal("hide");
              $.bigBox({
                title : "Information Tips",
                content : "You have successfully added subscribers.",
                color : "#739E73",
                timeout: 6000,
                icon : "fa fa-check",
                number : "Congratulation"
              });
              let body = {
                currentPage: 1,
                pageSize: that.state.pageSize
              };
              _getSubscribers(body);
            }
          })
          .catch(err=>{
            console.log(err);
          });
      },
      errorPlacement: function (error, element) {
        error.insertAfter(element.parent());
      }
    });
    $(document).on("click","#selectAll",function() {
      let curStatus = $(this).prop("checked");
      if (curStatus) {
        $("#subscribTable [name='checkbox-inline']").prop("checked",true);
      } else {
        $("#subscribTable [name='checkbox-inline']").prop("checked",false);
      }
    });
    $(document).on("click",".close",function(){
      that._resetForm();
      $("#addrow_modal").modal("hide");
    });
    $('#finishdate').datepicker({
      dateFormat : 'mm/dd/yy',
      prevText : '<i class="fa fa-chevron-left"></i>',
      nextText : '<i class="fa fa-chevron-right"></i>'
    });
    $('#startdate').datepicker({
      dateFormat : 'mm/dd/yy',
      prevText : '<i class="fa fa-chevron-left"></i>',
      nextText : '<i class="fa fa-chevron-right"></i>'
    });
  };
  _resetForm = () => {
    $("#clientId").val("");
    $("#email").val("");
    $(".state-success").removeClass("state-success");
    $(".state-error").removeClass("state-error");
    $("em.invalid").remove();
  };
  _getSubscribers = body => {
    if (this.props.loginAdmin === "isos") body.tenantName = this.props.tenantInfo.name;
    else body.tenantName = this.props.loginAdmin;
    findSubscriberList(body)
      .then(res=>{
        let data = res.data || {};
        if (this.mounted) {
          this.setState({
            dataRows: data.list,
            totalRows: data.totalRows,
            currentPage: data.currentPage
          });
        }
      })
      .catch(err=>{
        console.log(err);
      });
  };
  _resetAll = () => {
    $("#searchSubscriber").find("input").val("");
    $('.select-head-cont').text($('.option-item')[0].innerHTML);
    // $("#subscribFlag")[0].selectedIndex = 0;
  };
  _deleteHandler = () => {
    let that = this;
    let subscriberArray = [];
    let subscriberChecked = $("#tb [name='checkbox-inline']:checked");
    $.each(subscriberChecked, function(index, item){
      subscriberArray.push($(item).attr("id"));
    });
    if (subscriberArray.length > 0) {
      Modal.confirm({
        msg: "Are you sure you want to delete"
      }).on(function (data) {
        if (data === true) {
          deleteSubscribers({ids: subscriberArray})
            .then(res => {
              $("#subscribTable [name='checkbox-inline']").prop("checked",false);
              $("#selectAll").prop("checked",false);
              $.bigBox({
                title : "Information Tips",
                content : "Delete success!",
                color : "#739E73",
                timeout: 6000,
                icon : "fa fa-check",
                number : "Congratulation"
              });
              let body = {
                currentPage: 1,
                pageSize: that.state.pageSize
              };
              that._getSubscribers(body);
            })
            .catch(err=>console.log(err));
        }
      });
    } else {
      $("#notSelect").modal("show");
    }
  };
  _searchHandler = () => {
    let search_clientId = $("#search-clientId").val().trim();
    let search_email = $("#search-email").val().trim();
    // let subscribFlag = $("#subscribFlag").val();
    let subscribFlag = $('.select-head-cont').text();
    if (subscribFlag === "All") subscribFlag = "";
    let search_startdate = $("#startdate").val();
    let search_finishdate = $("#finishdate").val();

    let body = {
      email: search_email,
      clientId: search_clientId,
      subscribFlag: subscribFlag,
      startTime: search_startdate,
      endTime: search_finishdate,
      currentPage: 1,
      pageSize: this.state.pageSize
    };
    this._getSubscribers(body);
  };
  _changeStatus = e => {
    let ele = $(e.target);
    let {loginAdmin, tenantInfo} = this.props;
    let body = {
      email: ele.attr("id"),
      status: ele.text(),
      tenantName: loginAdmin === "isos" ? tenantInfo.name : loginAdmin
    };
    changeSubStatus(body)
      .then(res=>{
        $.sound_on = false;
        $.smallBox({
          title : "Alert",
          content : "Successfully changed state!",
          color : "#296191",
          iconSmall : "fa fa-thumbs-up bounce animated",
          timeout : 2000
        });
        let body = {
          currentPage: this.state.currentPage,
          pageSize: this.state.pageSize
        };
        this._getSubscribers(body);
      })
      .catch(err=>console.log(err))
  };
  _onChange = page => {
    $("#subscribTable [name='checkbox-inline']").prop("checked",false);
    $("#selectAll").prop("checked",false);
    let search_clientId = $("#search-clientId").val().trim();
    let search_email = $("#search-email").val().trim();
    // let subscribFlag = $("#subscribFlag").val();
    let subscribFlag = $('.select-head-cont').text();
    if (subscribFlag === "All") subscribFlag = "";
    let search_startdate = $("#startdate").val();
    let search_finishdate = $("#finishdate").val();
    let body = {
      email: search_email,
      clientId: search_clientId,
      subscribFlag: subscribFlag,
      startTime: search_startdate,
      endTime: search_finishdate,
      currentPage: page,
      pageSize: this.state.pageSize
    };
    if (this.mounted) {
      this.setState({current: page});
    }
    this._getSubscribers(body);
  };
  _initSelect = () => {
    let selectHeadCont = $('.select-head-cont');
    let Option = $('.option');
    let optionItem = $('.option-item');

    selectHeadCont.text(optionItem[0].innerHTML);
    $(document).on("click", function () {
      Option.hide();
    }).on("click", ".select-head", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (Option.is(":hidden")) Option.show();
      else Option.hide();
    }).on("click", ".option-item", function (e) {
      e.preventDefault();
      e.stopPropagation();
      selectHeadCont.text($(this).text());
      Option.hide();
    });
  };

  render() {
    let { dataRows, totalRows, currentPage, pageSize } = this.state;
    let { loginAdmin, tenantInfo } = this.props;
    let downloadName = loginAdmin==="isos"?tenantInfo.name:loginAdmin;
    let token = sessionStorage.getItem("token");
    let companyName;
    if (tenantInfo && tenantInfo.companyName) companyName = tenantInfo.companyName;
    return (
      <div>
        <div id="ribbon">
          {/*<span className="ribbon-button-alignment">*/}
            {/*<span id="refresh"*/}
                  {/*className="btn btn-ribbon"*/}
                  {/*data-action="resetWidgets"*/}
                  {/*data-title="refresh"*/}
                  {/*rel="tooltip"*/}
                  {/*data-placement="bottom"*/}
                  {/*data-original-title="<i className='text-warning fa fa-warning'></i> Warning! This will reset all your widget settings."*/}
                  {/*data-html="true">*/}
              {/*<i className="fa fa-refresh" />*/}
            {/*</span>*/}
          {/*</span>*/}
          <ol className="breadcrumb">
            <li>{`${companyName.toUpperCase()} Subscribers List`}</li>
          </ol>
        </div>
        <div id="content">
          <div className="row">
            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-4">
              <h1 className="page-title txt-color-blueDark">
                <i className="fa fa-table fa-fw " />
                {`${companyName.toUpperCase()} Subscribers List`}
              </h1>
            </div>
          </div>
          <section id="widget-grid" className="">
            <div className="row">
              <article className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="jarviswidget jarviswidget-color-darken"
                     id="wid-id-0"
                     data-widget-editbutton="false"
                     data-widget-deletebutton="false">
                  <header>
                    <span className="widget-icon">
                      <i className="fa fa-table" />
                    </span>
                    <h2>Subscriber Administration Center</h2>
                  </header>
                  <div>
                    <div className="jarviswidget-editbox" />
                    <div className="widget-body no-padding">
                      <div className="toolbar clearfix">
                        <form id="searchSubscriber">
                          <div className="row">
                            <div className="col-md-2 col-lg-1 col-sm-6 search-input">
                              <div className="smart-form-width smart-form client-form">
                                <label className="input">
                                  <input autoFocus="autofocus"
                                         id="search-clientId"
                                         name="clientId"
                                         className="form-control"
                                         type="text"
                                         placeholder="Company Name"
                                         aria-controls="dt_basic" />
                                  <b className="tooltip tooltip-top-right">
                                    <i className="fa fa-tags txt-color-teal" /> Search by Company Name
                                  </b>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2 col-lg-1 col-sm-6 search-input">
                              <div className="smart-form-width smart-form client-form ">
                                <label className="input">
                                  <input id="search-email"
                                         name="email"
                                         className="form-control"
                                         type="text"
                                         placeholder="Email"
                                         aria-controls="dt_basic" />
                                  <b className="tooltip tooltip-top-right">
                                    <i className="fa fa-envelope txt-color-teal" /> Search by Email
                                  </b>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2 col-sm-6 search-subscribFlag">
                              <div className="mb10">
                                {/*<select id="subscribFlag"*/}
                                        {/*name="subscribFlag"*/}
                                        {/*className="form-control"*/}
                                        {/*size="1">*/}
                                  {/*<option value="">All</option>*/}
                                  {/*<option value="Subscribed">Subscribed</option>*/}
                                  {/*<option value="Unsubscribed">Unsubscribed</option>*/}
                                {/*</select>*/}
                                <ul id="userSelect">
                                  <li>
                                    <div className="select-head">
                                      <span className="select-head-cont" />
                                      <span className="select-icon">▼</span>
                                    </div>
                                    <ul className="option">
                                      <li className="option-item">All</li>
                                      <li className="option-item">Subscribed</li>
                                      <li className="option-item">Unsubscribed</li>
                                    </ul>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-md-4 col-sm-6">
                              <div className="smart-form mb10">
                                <label className="input" style={{display: 'inline-block'}}>
                                  <i className="icon-append fa fa-calendar"
                                     style={{zIndex: 6}}/>
                                  <input type="text"
                                         placeholder="From"
                                         name="startTime"
                                         id="startdate"
                                         style={{zIndex: 5, position: 'relative'}}
                                         readOnly />
                                </label>&nbsp;
                                <label className="input" style={{display: 'inline-block'}}>
                                  <i className="icon-append fa fa-calendar"
                                     style={{zIndex: 6}}/>
                                  <input type="text"
                                         placeholder="To"
                                         name="endTime"
                                         id="finishdate"
                                         style={{zIndex: 5, position: 'relative'}}
                                         readOnly />
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2 col-sm-6" style={{minWidth: 174}}>
                              <button className="btn btn-primary mb10"
                                      onClick={this._searchHandler}
                                      type="button">
                                <i className="glyphicon glyphicon-search" /> Search
                              </button>
                              <button type="button"
                                      onClick={this._resetAll}
                                      className="btn btn-success search"
                                      style={{margin: '-10px 0 0 3px'}}>
                                Clear
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <table id="subscribTable"
                             className="table table-striped table-bordered table-hover smart-form"
                             width="100%">
                        <thead>
                          <tr width="2%">
                            <th>
                              <label className="checkbox">
                                <input type="checkbox"
                                       name="checkbox-inline"
                                       id="selectAll" />
                                  <i />
                              </label>
                            </th>
                            <th data-hide="IN">Company Name</th>
                            <th>Email</th>
                            <th data-hide="phone,tablet">Date</th>
                            <th data-hide="phone,tablet">Subscription Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody id="tb">
                        {
                          dataRows.map((row, index) => {
                            return (
                              <tr key={index}>
                                <td style={{width: 60}}>
                                  <label className="checkbox">
                                    <input type="checkbox" name="checkbox-inline" id={row.id}/>
                                    <i />
                                  </label>
                                </td>
                                <td>{row.clientId}</td>
                                <td>
                                  <Link to={`/admin/subscribers/subscription/${row.id}`}>
                                    {row.email}
                                  </Link>
                                </td>
                                <td>{row.createdOn?row.createdOn.slice(0, 10):''}</td>
                                {/*<td>{row.joinedOnString}</td>*/}
                                <td>{row.subscribFlag}</td>
                                <td className="action">
                                  <a href="javascript:"
                                     id={row.email}
                                     onClick={this._changeStatus}
                                     className="btn btn-info btn-status">
                                    {`${row.status==='Disable'?'Enable':'Disable'}`}
                                  </a>
                                </td>
                              </tr>
                            );
                          })
                        }
                        </tbody>
                      </table>
                      <div className="toolbar-bottom">
                        <div className="row">
                          <div className="col-xs-4">
                            <div className='btn-group pull-left'>
                              <a className='btn btn-sm btn-primary'
                                 onClick={()=>location.reload()}
                                 href='javascript:'>
                                <span className='fa fa-refresh' />
                              </a>
                              <a className="btn btn-sm btn-primary"
                                 data-toggle="modal"
                                 data-target="#addrow_modal">
                                <span className="fa fa-plus" />
                              </a>
                              <a className='btn btn-sm btn-primary'
                                 href={`/api/subscribe/downloadLocal?tenantName=${downloadName}&token=${token}`} >
                                <span className='fa fa-download' />
                              </a>
                              <a className='btn btn-sm btn-primary btn-remove'
                                 onClick={this._deleteHandler}>
                                <span className='fa fa-trash-o' />
                              </a>
                            </div>
                          </div>
                          <div className="col-xs-3">
                            <div className="dataTables_info" aria-live="polite">
                              <span className="text-primary totalRows">{totalRows}</span> entries
                            </div>
                          </div>
                          <div className="col-xs-5">
                            <Pagination
                              className="pull-right"
                              pageSize={pageSize}
                              defaultCurrent={1}
                              onChange={this._onChange}
                              current={currentPage}
                              total={totalRows}
                              showLessItems
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </section>
        </div>
        {/*add subscriber modal*/}
        <div className="modal fade"
             id="addrow_modal"
             role="dialog"
             aria-labelledby="myModalLabel"
             aria-hidden="true"
             data-backdrop="static">
          <div className="modal-dialog">
            <form id="addForm" className="form-horizontal">
              <div className="modal-content"
                   style={{backgroundColor: '#E6E6E6', borderRadius: 7}}>
                <div className="modal-header"
                     style={{borderTopRightRadius: 5, borderTopLeftRadius: 5}}>
                <span className="pull-right">
                  <i className=" close fa fa-lg fa-times" />
                </span>
                  <h4 className="modal-title"> Add subscriber</h4>
                </div>
                <div className="modal-body">
                  <div className="smart-form client-form">
                    <section className="form-group">
                      <label className="input">
                        <input id="clientId"
                               className="form-control"
                               name="clientId"
                               type="text"
                               placeholder="Please enter a company name" />
                        <b className="tooltip tooltip-top-right">
                          <i className="fa fa-tags txt-color-teal" />
                          &nbsp;Please enter a company name
                        </b>
                      </label>
                    </section>
                    <br />
                    <section className="form-group">
                      <label className="input">
                        <input id="email"
                               className="form-control"
                               name="email"
                               type="email"
                               placeholder="Please enter an email address" />
                        <b className="tooltip tooltip-top-right">
                          <i className="fa fa-envelope txt-color-teal" />
                          &nbsp;Please enter an email address
                        </b>
                      </label>
                    </section>
                  </div>
                </div>
                <div className="modal-footer" style={{borderTop: '1px solid #ababab'}}>
                  <button id="modalConfirm" type="submit" className="btn btn-primary">Confirm</button>
                  <button className="btn btn-success"
                          onClick={e=>{
                            e.preventDefault();
                            this._resetForm();
                          }}>
                    Clear
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="modal fade" id="notSelect">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title">
                  <i className="fa fa-exclamation-circle" /> &nbsp;Information Tips
                </h4>
              </div>
              <div className="modal-body">
                <div className="alert alert-block">
                  <p>Please choose datas what you want to delete</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="ycf-alert" className="modal">
          <div className="modal-dialog modal-sm">
            <div className="modal-content"
                 style={{
                   backgroundColor: '#e6e6e6',
                   borderRadius: '7px'
                 }}>
              <div className="modal-header"
                   style={{
                     borderTopRightRadius: '5px',
                     borderTopLeftRadius: '5px'
                   }}>
                <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
                <h5 className="modal-title"><i className="fa fa-exclamation-circle" /> [Title]</h5>
              </div>
              <div className="modal-body small">
                <p>[Message]</p>
              </div>
              <div className="modal-footer" >
                <button type="button" className="btn btn-primary ok" data-dismiss="modal">
                  [BtnOk]
                </button>
                <button type="button" className="btn btn-default cancel" data-dismiss="modal">
                  [BtnCancel]
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/dashboard/model/subscribers.js